import { useQuery } from "@tanstack/react-query";
import { ApiError } from "pages/admin-app/shared/models/response/api-errors";
import { ORDER_BY, PER_PAGE } from "pages/admin-app/adminapp.constants";
import { GetDistributorsResponse } from "../models/response/get-distributors-response";
import { getDistributors } from "../services/distributor-service";

interface Props {
  currentPage: number;
  sortBy?: string;
  orderBy?: ORDER_BY;
  filters?: { [key: string]: string };
  searchQuery?: string;
}

export function useDistributors({
  currentPage,
  sortBy,
  orderBy,
  filters,
  searchQuery,
}: Props) {
  const { data, error, isLoading, isError, refetch, isFetching } = useQuery<
    GetDistributorsResponse,
    ApiError
  >({
    queryKey: [
      "distributors",
      currentPage,
      sortBy,
      orderBy,
      filters,
      searchQuery,
    ],
    queryFn: () =>
      getDistributors({
        page: currentPage,
        perPage: PER_PAGE,
        sortBy,
        orderBy,
        filters,
        searchQuery,
      }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
    isFetching,
  };
}
